/////////////////////////////////////////////
// DEFAULT PROPS FOR COMPONENTS
/////////////////////////////////////////////
export { DEFAULT_PROPS } from './default-props';

/////////////////////////////////////////////
// COLOR CONFIGURATION
/////////////////////////////////////////////
export const BG_COLOR = {
  primary: '#fffbf7',
  secondary: '#eedec5',
  alternative: '#6b5124',
};

export const TEXT_COLOR = {
  primary: '#291d0b',
  secondary: '#6b5124',
  alternative: '#96692f',
};

export const NAVIGATION_COLOR = {
  base: BG_COLOR.alternative,
  icon: `#FFF`,
};

